import {Requests, defaultErrorHandler} from './base'

function scoringRequest (param, $parent) {

  return Requests.post('https://k2v1llw233.execute-api.ap-northeast-1.amazonaws.com/v1/scoring', param)
    .then(response => {
      return response
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

export {scoringRequest}



// WEBPACK FOOTER //
// ./src/modules/request/scoring.js